import { Container } from "@mui/material";

import HeaderContent from "./section/headerContent";
import Contact from "./section/contact";
import Visi from "./section/visi";
import Sectionimage from "./section/sectionimage";
import Blog from "./blog/blog";
import DetailBlog from "./blog/detailBlog";
import Kegiatan from "./kegiatan/kegiatan";
import DetailKegiatan from "./kegiatan/detailKegiatan";
import About from "./about/about";
import DetailAbout from "./about/detailAbout";

import {
    BreadcrumbAbout,
    BreadcrumbBlog,
    BreadcrumbKegiatan,
} from "../components/containerBreadcrumb";

export function LandingPageHome() {
    return (
        <div id="home">
            <HeaderContent />
            <About />
            <Kegiatan />
            <Sectionimage />
            <Visi />
            <Blog />
            <Contact />
        </div>
    );
}

export function DetailBlogContent() {
    return (
        <>
            <BreadcrumbBlog />
            <Container>
                <DetailBlog />
            </Container>
            <Contact />
        </>
    );
}

export function DetailKegiatanContent() {
    return (
        <>
            <BreadcrumbKegiatan />
            <Container>
                <DetailKegiatan />
            </Container>
            <Contact />
        </>
    );
}

export function DetailAboutContent() {
    return (
        <>
            <BreadcrumbAbout />
            <Container>
                <DetailAbout />
            </Container>
            <Contact />
        </>
    );
}
